import { useTranslation } from '@shared/core';
import { FabButton, Flex } from '@withjoy/joykit';
import React from 'react';

type SaveCancelButtonsProps = Readonly<{
  readonly onCancel: (event: React.MouseEvent<HTMLButtonElement>) => void;
  readonly onSave: (event: React.MouseEvent<HTMLButtonElement>) => void;
  readonly isLoading?: boolean;
  readonly isSaveDisabled?: boolean;
  readonly cancelCtaText?: string;
  readonly saveCtaText?: string;
}>;

export const SaveCancelButtons: React.FC<SaveCancelButtonsProps> = ({ onCancel, onSave, isLoading, isSaveDisabled, cancelCtaText, saveCtaText }) => {
  const { tq } = useTranslation('websiteEditor');

  return (
    <Flex
      gap={6}
      width="100%"
      position="sticky"
      marginTop={8}
      zIndex={1}
      bottom={5}
      left={5}
      right={5}
    >
      <FabButton
        width="100%"
        variant="outline"
        onClick={onCancel}
      >
        {cancelCtaText || tq`Cancel`}
      </FabButton>
      <FabButton
        backgroundColor="buttonNeutralFill"
        width="100%"
        type="button"
        variant="solid"
        loading={isLoading}
        disabled={isLoading || isSaveDisabled}
        onClick={onSave}
      >
        {saveCtaText || tq`Save`}
      </FabButton>
    </Flex>
  );
};
